"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaultsSelectors = exports.FaultsAccessors = void 0;
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable max-classes-per-file */
var reselect_1 = require("reselect");
var moment_1 = __importDefault(require("moment"));
var units_1 = __importDefault(require("@dtna/dvs-core-dcp-client-constants/lib/constants/units"));
var dvs_core_dcp_client_constants_1 = __importDefault(require("@dtna/dvs-core-dcp-client-constants"));
var faults_1 = require("../utils/faults");
var faults_2 = require("../constants/faults");
var filterBar_1 = require("../constants/filterBar");
var faults_model_1 = require("../models/faults.model");
var table_selector_1 = require("./table.selector");
var vehicle_model_1 = require("../models/vehicle.model");
var user_model_1 = require("../models/user.model");
var user_selector_1 = require("./user.selector");
var N_A = dvs_core_dcp_client_constants_1.default.SHARED_LOCALE_STRINGS.LABELS.N_A;
var FaultsAccessors = /** @class */ (function () {
    function FaultsAccessors() {
    }
    /** Fetches the VehicleInfo sub-state from the RootState */
    FaultsAccessors.getFaultsDateRange = function (rootState) {
        var serializedDateRange = rootState.faults.dateRange;
        return {
            startDate: serializedDateRange.startDate ? (0, moment_1.default)(serializedDateRange.startDate) : null,
            endDate: serializedDateRange.endDate ? (0, moment_1.default)(serializedDateRange.endDate) : null,
        };
    };
    FaultsAccessors.getFaultsState = function (rootState) { return rootState.faults; };
    FaultsAccessors.getFaultsDetailsError = function (rootState) { return rootState.faults.faultDetailsError; };
    FaultsAccessors.getFaultsDescriptionsError = function (rootState) { return rootState.faults.faultDescriptionsError; };
    FaultsAccessors.getFaultDetails = function (event) { return function (state) { return state.faults.faultDetails && state.faults.faultDetails[event]; }; };
    FaultsAccessors.getAllFaultDetails = function (state) { return state.faults.faultDetails; };
    FaultsAccessors.getFaultDetailsLoadingStatus = function (state) { return state.faults.isLoadingFaultDetails || state.faults.isLoadingFaultDescriptions; };
    FaultsAccessors.getFaultDescriptions = function (state) { return state.faults.faultDescriptions; };
    FaultsAccessors.getFaultIsFlagged = function (event) { return function (state) { return (!!(state.faults.flags && state.faults.flags[event])); }; };
    FaultsAccessors.getFaultInboxLoading = function (rootState) { return rootState.faults.faultInboxLoading; };
    FaultsAccessors.getFaultInboxLoadingError = function (rootState) { return rootState.faults.faultInboxLoadingError; };
    FaultsAccessors.getFaultRingBufferData = function (event) { return function (state) { return (state.faults.ringBufferData && state.faults.ringBufferData[event]
        ? state.faults.ringBufferData[event]
        : {}); }; };
    FaultsAccessors.getFaultInboxPaging = function (rootState) { return rootState.faults.faultInboxPaging; };
    FaultsAccessors.getFaultsInboxData = function (rootState) { return rootState.faults.faultInbox; };
    FaultsAccessors.getFaultsPendingFlagOperations = function (rootState) { return rootState.faults.pendingFlagOperations; };
    FaultsAccessors.getFaultsFlags = function (rootState) { return rootState.faults.flags; };
    FaultsAccessors.getFaultsInboxIsDownloadingCsv = function (rootState) { return rootState.faults.isDownloadingCsv; };
    FaultsAccessors.getFaultsInboxIsResolvedView = function (rootState) { return !!rootState.faults.isResolvedView; };
    FaultsAccessors.getSelectedFaultForDetailsModal = function (rootState) { return rootState.faults.selectedFaultForDetailsModal; };
    FaultsAccessors.getIsLoadingFaultDescriptions = function (rootState) { return rootState.faults.isLoadingFaultDescriptions; };
    FaultsAccessors.getToggleIsResolvedIsLoading = function (rootState) { return rootState.faults.isLoadingToggleIsResolved; };
    FaultsAccessors.getToggleIsResolvedError = function (rootState) { return rootState.faults.toggleIsResolvedError; };
    FaultsAccessors.getFaultOdometer = function (eventId) { return function (state) { return state.faults.faultDetails
        && state.faults.faultDetails[eventId]
        && state.faults.faultDetails[eventId].odometer; }; };
    FaultsAccessors.getFaultTimeStamp = function (eventId) { return function (state) { return (state.faults.faultDetails && state.faults.faultDetails[eventId]
        ? state.faults.faultDetails[eventId].timestamp
        : 0); }; };
    FaultsAccessors.getRingBufferDataError = function (rootState) { return rootState.faults.ringBufferDataError; };
    FaultsAccessors.getIsLoadingRingBufferData = function (rootState) { return rootState.faults.isLoadingRingBufferData; };
    FaultsAccessors.getFaultsFilterBarFilters = function (state) { return state.filterBar[filterBar_1.FILTER_BAR_IDS.FAULTS_LIST] || {}; };
    FaultsAccessors.getAnalyticsFilters = function (filterBarId) { return function (state) { return (!!state.filterBar[filterBarId]
        ? state.filterBar[filterBarId]
        : {}); }; };
    FaultsAccessors.getFaultsFilters = function (state) { return state.faults.faultFilters; };
    return FaultsAccessors;
}());
exports.FaultsAccessors = FaultsAccessors;
var FaultsSelectors = /** @class */ (function () {
    function FaultsSelectors() {
    }
    FaultsSelectors.selectFaultsHasFlags = (0, reselect_1.createSelector)([FaultsAccessors.getFaultsFlags], function (flags) { return Object.keys(flags).length > 0; });
    FaultsSelectors.selectCustomerCanResolveFaults = (0, reselect_1.createSelector)([user_selector_1.UserAccessors.getCustomer], function (customer) { return !!customer && customer.CanResolveFaults; });
    FaultsSelectors.selectFaultsToResolveObjects = function (tableId) { return (0, reselect_1.createSelector)([
        table_selector_1.TableSelectors.selectSelectedRows(tableId),
        FaultsAccessors.getFaultsInboxData,
    ], function (rowKeys, faults) { return faults.filter(function (f) { return rowKeys.includes(f.rowKey); }); }); };
    FaultsSelectors.getFaultDescription = function (event) { return (0, reselect_1.createSelector)([
        FaultsAccessors.getFaultDetails(event),
        FaultsAccessors.getFaultDescriptions,
    ], function (fault, descriptions) {
        var Spn = fault && fault.spn;
        var Fmi = fault && fault.fmi;
        if (typeof Spn === 'number' && typeof Fmi === 'number') {
            var key = "".concat(Spn, ":").concat(Fmi);
            var faultDescriptions = descriptions[key];
            return faultDescriptions && faultDescriptions.ExtendedServiceNotes
                ? faultDescriptions.ExtendedServiceNotes.replace(/\\n\\n\s*/g, '\n\n')
                : '';
        }
        return '';
    }); };
    FaultsSelectors.getSelectedFaultDetails = (0, reselect_1.createSelector)([
        FaultsAccessors.getAllFaultDetails,
        FaultsAccessors.getSelectedFaultForDetailsModal,
    ], function (faults, selectedFault) {
        if (faults && selectedFault) {
            return Object.values(faults).find(function (el) { return el.vtEventId === selectedFault.vtEventId; });
        }
        return null;
    });
    FaultsSelectors.getSelectedFaultEventId = (0, reselect_1.createSelector)([FaultsSelectors.getSelectedFaultDetails], function (faultDetails) { return (faultDetails ? faultDetails.eventId : ''); });
    FaultsSelectors.getFaultIsRingBuffer = function (event) { return (0, reselect_1.createSelector)([FaultsAccessors.getFaultDetails(event)], function (fault) { return !!fault && fault.faultType === faults_model_1.FaultTypes.RING_BUFFER; }); };
    FaultsSelectors.selectFaultsInboxTeletableData = (0, reselect_1.createSelector)([
        FaultsAccessors.getFaultsInboxData,
        FaultsAccessors.getFaultsFlags,
        FaultsAccessors.getFaultsPendingFlagOperations,
    ], function (faultInboxData, flags, pendingFlagOperations) {
        var faultTableRows = faultInboxData.map(function (fault) {
            var flagStatus;
            if (pendingFlagOperations.some(function (operationFaultId) { return operationFaultId === fault.vtEventId; })) {
                flagStatus = faults_model_1.FLAG_STATUS.LOADING;
            }
            else if (Object.keys(flags).some(function (faultId) { return faultId === fault.vtEventId; })) {
                flagStatus = faults_model_1.FLAG_STATUS.IS_FLAGGED;
            }
            else {
                flagStatus = faults_model_1.FLAG_STATUS.NOT_FLAGGED;
            }
            return __assign(__assign({}, fault), { source: fault.source === vehicle_model_1.ENGINE_MANUFACTURER.CUMMINS ? fault.source : vehicle_model_1.ENGINE_MANUFACTURER.DETROIT, flagStatus: flagStatus });
        });
        return faultTableRows;
    });
    FaultsSelectors.selectFaultDetailsByEvent = function (event) { return (0, reselect_1.createSelector)([FaultsAccessors.getAllFaultDetails], function (allFaults) { return (allFaults ? allFaults[event] : null); }); };
    FaultsSelectors.selectClosestTimeStampRingBufferValue = function (vtEventId, eventId) { return (0, reselect_1.createSelector)([FaultsAccessors.getFaultRingBufferData(vtEventId), FaultsAccessors.getFaultTimeStamp(eventId)], function (data, ts) {
        var newData = {};
        Object.keys(data).forEach(function (item) {
            var closestTimeStampValue = (0, faults_1.findClosestKeyIndex)(data[item].values, 'ts', ts);
            newData[item] = __assign(__assign({}, data[item]), { Values: data[item].values[closestTimeStampValue] });
        });
        return newData;
    }); };
    FaultsSelectors.selectEventDetailHeaderData = function (vtEventId, eventId) { return (0, reselect_1.createSelector)([
        FaultsSelectors.selectClosestTimeStampRingBufferValue(vtEventId, eventId),
        FaultsAccessors.getFaultOdometer(eventId),
        user_selector_1.UserAccessors.getUserUnitsSystemType,
    ], function (value, odometer, userUnitsSystemType) {
        var _a;
        var engineSpeedData = value[faults_2.FAULT_RING_BUFFER_DATA_TYPES.ENGINE_SPEED];
        var engineLoadData = value[faults_2.FAULT_RING_BUFFER_DATA_TYPES.ENGINE_LOAD];
        var actualTorqueData = value[faults_2.FAULT_RING_BUFFER_DATA_TYPES.ACTUAL_TORQUE];
        var batteryVoltageData = value[faults_2.FAULT_RING_BUFFER_DATA_TYPES.BATTERY_VOLTAGE];
        var vehicleSpeedData = value[faults_2.FAULT_RING_BUFFER_DATA_TYPES.VEHICLE_SPEED];
        var odometerUnit = userUnitsSystemType === user_model_1.UNITS_SYSTEM_TYPES.METRIC ? units_1.default.KILOMETERS : units_1.default.MILES;
        var speedUnit = userUnitsSystemType === user_model_1.UNITS_SYSTEM_TYPES.METRIC ? units_1.default.KILOMETERS_PER_HOUR : units_1.default.MILES_PER_HOUR;
        var odometerUnitString = dvs_core_dcp_client_constants_1.default.UNITS[odometerUnit];
        var speedUnitString = dvs_core_dcp_client_constants_1.default.UNITS[speedUnit];
        var percentUnitString = dvs_core_dcp_client_constants_1.default.UNITS[units_1.default.PERCENT];
        var rpmUnitString = dvs_core_dcp_client_constants_1.default.UNITS[units_1.default.RPM];
        var voltageUnitString = dvs_core_dcp_client_constants_1.default.UNITS[units_1.default.VOLTS];
        return _a = {},
            _a[faults_2.FAULT_EVENT_DETAIL_HEADER_TITLES.ODOMETER] = odometer ? "".concat(odometer.toFixed(1), " ").concat(odometerUnitString) : N_A,
            _a[faults_2.FAULT_EVENT_DETAIL_HEADER_TITLES.ENGINE_LOAD] = engineLoadData ? "".concat(engineLoadData.Values.value.toFixed(0), " ").concat(percentUnitString) : '',
            _a[faults_2.FAULT_EVENT_DETAIL_HEADER_TITLES.ACTUAL_TORQUE] = actualTorqueData ? "".concat(actualTorqueData.Values.value.toFixed(0), " ").concat(percentUnitString) : '',
            _a[faults_2.FAULT_EVENT_DETAIL_HEADER_TITLES.ENGINE_SPEED] = engineSpeedData ? "".concat(engineSpeedData.Values.value.toFixed(1), " ").concat(rpmUnitString) : '',
            _a[faults_2.FAULT_EVENT_DETAIL_HEADER_TITLES.BATTERY_VOLTAGE] = batteryVoltageData ? "".concat(batteryVoltageData.Values.value.toFixed(1), " ").concat(voltageUnitString) : N_A,
            _a[faults_2.FAULT_EVENT_DETAIL_HEADER_TITLES.VEHICLE_SPEED] = vehicleSpeedData ? "".concat(vehicleSpeedData.Values.value.toFixed(1), " ").concat(speedUnitString) : '',
            _a;
    }); };
    return FaultsSelectors;
}());
exports.FaultsSelectors = FaultsSelectors;
